/**
 * Geometry Type Enum
 *
 * Defines the types of geometric representations available for tasks on the map.
 *
 * @enum {string}
 */
export enum GeometryType {
  /**
   * Navigation mode - no drawing
   * Allows hover and context menu without drawing risk
   * Similar to pointer/hand tool in Figma/Canva/Photoshop
   * @since 3.0.0
   */
  None = 'None',

  /**
   * Selection mode - select and edit geometries
   * Allows selecting geometries without activating drawing tools
   * Double-click to activate edit mode, DEL to delete
   * Supports vertex selection for lines
   * @since 3.0.0
   */
  Selection = 'Selection',

  /**
   * Single point marker
   * Default representation type for tasks
   */
  Marker = 'Marker',

  /**
   * Multi-point polyline
   * Used for representing linear features (roads, paths, etc.)
   * Requires minimum 2 points
   */
  Line = 'Line',

  /**
   * Closed polygon shape
   * Used for representing areas (zones, regions, etc.)
   * Supports rectangle, circle, and triangle
   */
  Shape = 'Shape',
}
